module.exports = __webpack_public_path__ + "60d649c0704a5e30a9ba8e1d114cc5dd.woff";